import axios from "axios";
import toast from "react-hot-toast";

import { useEffect, useState } from "react";
import { fetchApi } from "../helpers/h";

// custom hooks for fetching data
export const useFetch = (
  {
    url = "",
    method = "GET",
    dataPost = {},
    dep = [],
    accept = "application/json",
    contentType = "application/json",
    dataKey = (res) => res?.data?.data || "",
    f = (res) => res,
    condition = true,
  },
  onLoad = () => {},
) => {
  const [data, setData] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  useEffect(() => {
    if (
      condition == "" ||
      condition == undefined ||
      condition == null ||
      condition == false
    )
      return;
    setIsLoading(true);
    setData(null);
    const cancelToken = axios.CancelToken.source();
    const tryFetch = async () => {
      try {
        const res = await fetchApi({
          url: url,
          method: method,
          data: dataPost,
          accept: accept,
          contentType: contentType,
          cancelToken: cancelToken.token,
        });
        f(dataKey(res));
        setData(dataKey(res));
        onLoad(dataKey(res));
      } catch {
        // console.log(error);
        toast.error("Server error. Please contact your admin.");
      } finally {
        setIsLoading(false);
      }
    };
    tryFetch();
    return () => cancelToken.cancel();
  }, [JSON.stringify(dep)]);

  return {
    data: data,
    setData: setData,
    isLoading: isLoading,
  };
};
